module.exports = __webpack_public_path__ + "media/npc_dota_hero_kez.bb1baeca.webm";